/**
 * @file Input component for showing resources using a requirement
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { EntityQuery } from 'breeze-client';
import { OverlayService } from '../../core/overlay.service';
import { AlertsService } from '../../core/alerts.service';
import { InputBase } from '../../base/inputs/input-base/input-base';
import { DomainService } from '../../domain.service';
/**
 * Class for input showing which resources use a requirement
 */
var InputInUseByComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputInUseByComponent, _super);
    /**
     * Constructs a InputInUseByComponent
     */
    function InputInUseByComponent(overlayService, alertsService, domainService) {
        var _this = _super.call(this) || this;
        _this.overlayService = overlayService;
        _this.alertsService = alertsService;
        _this.domainService = domainService;
        /** Number of resources visible in view */
        _this.visibleResources = 3;
        /** All resources */
        _this.resources = [];
        /**
         * Holds the reference of the entity format.
         * @private
         * @type {EntityFormat}
         */
        _this.formatValue = undefined;
        return _this;
    }
    Object.defineProperty(InputInUseByComponent.prototype, "format", {
        /**
         * Sets the entity format of the lookup, which entity and properties are used.
         */
        get: function () {
            return this.formatValue;
        },
        /**
         * Sets the entity format of the lookup, which entity and properties are used.
         */
        set: function (value) {
            if (value === this.formatValue) {
                return;
            }
            this.formatValue = value;
        },
        enumerable: true,
        configurable: true
    });
    InputInUseByComponent.prototype.setValue = function (val) {
        _super.prototype.setValue.call(this, val);
        if (!val) {
            return;
        }
        if (!this.format) {
            return;
        }
        this.update(this.format.dataSource, this.value);
    };
    /**
     * get data from datasource
     * @param dataSource endpoint name
     * @param val Oid value
     */
    InputInUseByComponent.prototype.update = function (dataSource, val) {
        var _this = this;
        if (!val) {
            return;
        }
        var query = EntityQuery.from(dataSource).orderBy('Name,FirstName');
        query.parameters = {
            className: val.entityType.shortName,
            oid: val['Oid'],
            impClass: 'Resource'
        };
        this.domainService.entityManager.executeQuery(query).then(function (response) {
            _this.resources = response.results;
        });
    };
    /**
     * A lifecycle hook that is called after Angular has fully initialized a component's view.
     * Define an ngAfterViewInit() method to handle any additional initialization tasks.
     */
    InputInUseByComponent.prototype.ngAfterViewInit = function () {
        var format = this.formatValue;
        if (!format) {
            throw new Error('Column inuseby has as no format');
        }
        var dataSource = format.dataSource;
        if (!dataSource) {
            throw new Error('Column inuseby has as no datasource');
        }
        this.update(dataSource, this.value);
    };
    /**
     * Open any given entity in the app
     * @param entity The entity to open
     */
    InputInUseByComponent.prototype.openEntity = function ($event, entity) {
        $event.stopPropagation();
        if (!entity || this.isInOverlay()) {
            return;
        }
        if (!this.overlayService.goToEntity(entity)) {
            this.alertsService.createAlert('warning', 'APP.LISTS.CAN_NOT_GO_TO_ENTITY');
        }
    };
    /**
     * Returns the first few resources
     */
    InputInUseByComponent.prototype.selection = function () {
        return (this.resources ? this.resources.slice(0, this.visibleResources) : []);
    };
    /**
     * Returns whether the overlay is already open
     */
    InputInUseByComponent.prototype.isInOverlay = function () {
        return this.overlayService.isOpen();
    };
    return InputInUseByComponent;
}(InputBase));
export { InputInUseByComponent };
